module.exports = __webpack_public_path__ + "img/aipay.f0ee34b7.jpg";